// extracted by mini-css-extract-plugin
module.exports = {"highlightSection":"_03ac169","slider":"_dcf9445","sticky":"_0a43f2a"};